<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="FileTextIcon" />
          <span>Teklif Bilgileri</span>
        </template>
        <validation-observer ref="simpleRules">
          <offer-form
            :submit-form="submitForm"
            :submit-status="submitStatus"
          />
        </validation-observer>
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="this.$route.params.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import OfferForm from '@/views/Admin/Offers/OfferForm.vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Add',
  components: {
    BTabs,
    BTab,
    OfferForm,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    ValidationObserver,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
    saveData() {
      return this.$store.getters['offers/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/offers/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.$store.commit('offers/RESET_DATA_ITEM')
    this.getRequestData()
    localize('tr')
  },
  methods: {
    getRequestData() {
      this.$store.dispatch('baskets/getDataView', this.$route.params.id_baskets)
        .then(response => {
          if (response) {
            this.getCustomer(response.id_customers)
            this.dataItem.id_customers = response.id_customers
            this.dataItem.id_baskets = this.$route.params.id_baskets
            this.setLines(response.items)
          }
        })
    },
    setLines(items) {
      items.forEach((item, index) => {
        let idCurrencies = null
        if (index === 0) {
          idCurrencies = item.id_currencies
        }
        this.dataItem.offer_lines.push({
          id: null,
          title: item.product,
          content: null,
          quantity: 1,
          listed_price: item.price,
          discounted_price: null,
          discount_amount: null,
          discount_rate: null,
          total_price: item.price,
          ordering: index + 1,
          currency: null,
          tax_rate: null,
          discountStatus: false,
          id_products: item.id_products,
          id_product_groups: item.id_product_groups,
          id_units: 1,
          id_currencies: idCurrencies,
          id_taxes: null,
        })
      })
    },
    getCustomer(id) {
      this.$store.dispatch('customers/getDataItem', id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('offers/saveData', this.dataItem)
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
